export class M3PDinamByActividad{
    public IdDinamica:string;
    public Valor:string;
    public Nombre:string;
}